import { logging } from '@js-sdk/debug-tools';
import { setup as msIESetup } from './ms_ie';
import { setup as v01bSetup } from './v0_1b';
import { setup as safariSetup } from './safari';
const debugLogger = logging.forTag('eme_polyfills.tester');
export function install() {
    if (navigator &&
        navigator.requestMediaKeySystemAccess &&
        MediaKeySystemAccess &&
        // New versions of Safari contain the new API, but is not currently
        // usable for external developer, so we need to distinguish.
        typeof WebKitMediaKeys === 'undefined' &&
        MediaKeySystemAccess.prototype.getConfiguration) {
        debugLogger.log('Using native EME implementation.');
        return 'native';
    }
    else if (HTMLMediaElement &&
        // @ts-ignore
        HTMLMediaElement.prototype.webkitGenerateKeyRequest) {
        debugLogger.log('Detected "webkit" Prefixed EME v0.1b. Polyfilling.');
        v01bSetup('webkit');
        return 'v0.1b-webkit';
    }
    else if (HTMLMediaElement &&
        // @ts-ignore
        HTMLMediaElement.prototype.generateKeyRequest) {
        debugLogger.log('Detected Unprefixed EME v0.1b. Polyfilling.');
        v01bSetup();
        return 'v0.1b';
    }
    else if (typeof MSMediaKeys !== 'undefined') {
        debugLogger.log('Detected MS IE EME. Polyfilling.');
        msIESetup();
        return 'ms-ie';
    }
    else if (typeof WebKitMediaKeys === 'function') {
        debugLogger.log('Detected Safari EME. Polyfilling.');
        safariSetup();
        return 'safari';
    }
    debugLogger.warn('Detected no EME APIs.');
    return null;
}
//# sourceMappingURL=index.js.map